import { SponsorshipStatusId } from '../sponsorship'
import { ProfileTypeRegister } from '../user'

// INFO: 1 = Propriedade e 2 = Patrocinador
export const IndicationTypeValues = ['1', '2'] as const
export type IndicationType = (typeof IndicationTypeValues)[number]

// INFO: 1 = Ativo e 2 = Inativo
export const IndicationStatusValues = ['1', '2'] as const
export type IndicationStatus = (typeof IndicationStatusValues)[number]

// INFO: 1 = paga e 2 = pendente
export const CommissionStatusValues = ['1', '2', '3'] as const
export type CommissionStatus = (typeof CommissionStatusValues)[number]

export interface PersonalAgentDataResponse {
  classificacao_agente: number
  documento: string
  email: string
  nome: string
  patrocinadores: number
  propriedades: number
  telefone: string
  total_comissoes_pagas: number
  total_comissoes_pendentes: number
  total_indicacoes: number
  tp_cadastro: ProfileTypeRegister
  imagem_perfil?: string
}

export interface IndicationsStatusResponse {
  id_status: IndicationStatus
  descricao: string
}
export interface TypesIndicationsResponse {
  id_indicacao: IndicationType
  descricao: string
}

export interface IndicationsAgentResponse {
  id_indicacao: string
  tipo_indicacao: IndicationType
  comissao_padrao: number
  motivo_comissao: string
  nome_recurso: string
  status_indicacao: {
    id_status: IndicationStatus
    descricao: string
  }
  dt_cadastro: string
  possui_comissao: boolean
}

export interface CreateIndicationRequest {
  tipo_indicacao: IndicationType
  id_recurso: string
  comissao_padrao: number
  motivo_comissao: string
}

export type IndicationUpdateRequest = Pick<
  CreateIndicationRequest,
  'comissao_padrao' | 'motivo_comissao'
>

export interface CreateIndicationResponse {
  id_indicacao: string
  dt_cadastro: string
}

export interface LinkedCommissionsInfo {
  id_comissao: string
  id_contrato: string
  nome_patrocinador: string
  nome_propriedade: string
  porcentagem_comissao: number
  status_patrocinio: {
    id_status: SponsorshipStatusId
    descricao: string
  }
  status_comissao: {
    id_status: CommissionStatus
    descricao: string
  }
  data_fim?: string
  data_inicial?: string
  data_repasse?: string
  comprovante_pagamento?: string
  valor_comissao: number
}

export interface LinkedCommissionsResponse {
  info_patrocinio: LinkedCommissionsInfo[]
  total_comissoes: number
}

export type ExpandedLinkedCommissionsNames = Pick<
  LinkedCommissionsInfo,
  'nome_propriedade' | 'nome_patrocinador'
>
